import React from 'react';
import { Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Header } from './Header';
import { Footer } from './Footer';
import { Toaster } from '../ui/sonner';

const RSS_URL = `${process.env.REACT_APP_BACKEND_URL}/api/rss.xml`;

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <link
          rel="alternate"
          type="application/rss+xml"
          title="Greg's Stuff — RSS Feed"
          href={RSS_URL}
        />
      </Helmet>
      <Header />
      <main id="main-content" className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}
